module.exports = {
          srcSet: "/_next/static/images/home-teaser2-260-6041cf844464956c56bd7a36b874dd66.jpg"+" 260w",
          images:[ {path: "/_next/static/images/home-teaser2-260-6041cf844464956c56bd7a36b874dd66.jpg",width: 260,height: 260}],
          src: "/_next/static/images/home-teaser2-260-6041cf844464956c56bd7a36b874dd66.jpg",
          toString:function(){return "/_next/static/images/home-teaser2-260-6041cf844464956c56bd7a36b874dd66.jpg"},
          
          width: 260,
          height: 260
        }